import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { RolesPermissionsService } from '../services/roles-permissions.service';
import { GlobalService } from '../services/global.service';
import { LoaderService } from '../loader/loader.service';

export const ACUserGuard: CanActivateFn = () => {
  const rolesService = inject(RolesPermissionsService);
  const globalService = inject(GlobalService);
  const loader = inject(LoaderService);
  const hasAccess =
    rolesService.hasPermission('WorkInstructionTab', 'VIEW') ||
    rolesService.hasPermission('GenerateUrls', 'CREATE') || rolesService.hasPermission('WorkInstructionTab', 'VIEW_LINK_WI');

  if (hasAccess) {
    loader.setLoadingState.set(true)
    return true;
  } else {
    globalService.navigateToHomeByView();
    return false;
  }
};
